import {
  Collapse,
  Grid,
  TextField,
  Typography,
  Button,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  IconButton,
  Badge,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import React, { useMemo, useState } from "react";
import { clone, isEmpty, isNil } from "ramda";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { getMuiTheme } from "../../../utils/utils";
import palette from "../../../../config/colorPalette";
import { ErrorText } from "../styled";
import { handleAlertConfig, handleZones, maxHandler, minHandler } from "../utils/utils";
import AlertConfig from "./alertConfig";

const MeasurementInfo = ({
  selectedEquipment,
  setSelectedEquipment,
  equipments,
  setEquipments,
  measureToggle,
  channelToggle,
  setChannelToggle,
  subToggle,
  setSubToggle,
  zones,
  setZones,
  zoneToggle,
  setZoneToggle,
  polylineDisplay,
  configData,
  moreSubsAllowed,
  assetsData,
  selectedAsset,
  equipmentTypes,
  disabled,
  errors,
  setErrors,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [openModal, setOpenModal] = useState(false);

  return (
    <section
      style={{
        position: "relative",
        width: "100%",
        borderRadius: "4px",
        border: `1px solid ${palette.primary}`,
        margin: "1.5rem 0",
      }}
    >
      <div style={{ padding: "1rem" }}>
        <h1>{intl.formatMessage({ id: "zone.management" })}</h1>
        <Grid>
          {selectedEquipment.channels.map((channel, channelIndex) => (
            <>
              {!isNil(channel.substructures) && !isEmpty(channel.substructures) && (
                <h2
                  style={{ margin: "1%" }}
                  onClick={() => {
                    let newChannelToggle = clone(channelToggle);
                    if (newChannelToggle[channelIndex]) {
                      newChannelToggle[channelIndex] = false;
                    } else {
                      newChannelToggle[channelIndex] = true;
                    }
                    setChannelToggle(newChannelToggle);
                  }}
                >
                  {channel.name} - {intl.formatMessage({ id: "channel.mayus" })} {channelIndex + 1}
                  {!channelToggle[channelIndex] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                </h2>
              )}
              <Collapse in={channelToggle[channelIndex]}>
                {!isNil(subToggle[channelIndex]) &&
                  channel.substructures.map((sub, indexSub) => {
                    return (
                      <div style={{ marginLeft: "2%" }}>
                        <h3
                          style={{ marginBottom: "2%" }}
                          onClick={() => {
                            let newSubToggle = clone(subToggle);
                            if (newSubToggle[channelIndex][indexSub]) {
                              newSubToggle[channelIndex][indexSub] = false;
                            } else {
                              newSubToggle[channelIndex][indexSub] = true;
                            }
                            setSubToggle(newSubToggle);
                          }}
                        >
                          {sub.name} - {intl.formatMessage({ id: "sub" })} {indexSub + 1}
                          {!subToggle[channelIndex][indexSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                        </h3>
                        <Collapse in={subToggle[channelIndex][indexSub]}>
                          <TextField
                            id={"equipment_zones" + equipments}
                            style={{ margin: "0 0.2rem 0.8rem" }}
                            defaultValue={selectedEquipment.channels[channelIndex].substructures[indexSub].zones.length}
                            inputProps={{ min: 1 }}
                            onChange={(e) => {
                              handleZones({
                                e,
                                equipments,
                                selectedEquipment,
                                channelIndex,
                                indexSub,
                                zoneToggle,
                                setEquipments,
                                setSelectedEquipment,
                              });
                            }}
                            type="number"
                            error={errors["equipment_zones" + equipments] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "measure.zones" })}
                            required
                            disabled={disabled}
                          ></TextField>
                          <Grid
                            container
                            spacing={1}
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                          >
                            {!isNil(zoneToggle[channelIndex]) &&
                              !isNil(zoneToggle[channelIndex][indexSub]) &&
                              selectedEquipment.channels[channelIndex].substructures[indexSub].zones.map(
                                (zone, zoneIndex) => (
                                  <Grid item>
                                    {!isNil(errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`]) ||
                                    !isNil(errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`]) ? (
                                      <Badge
                                        sx={{
                                          "& .MuiBadge-badge": {
                                            backgroundColor: "red",
                                            color: "red",
                                            top: 10,
                                            right: 2,
                                          },
                                        }}
                                        badgeContent=" "
                                      >
                                        <Button
                                          variant="contained"
                                          style={{
                                            margin: "0.5rem 0 0 0.5rem",
                                            backgroundColor: palette.secondary,
                                            color: "white",
                                          }}
                                          id={`channel${channelIndex}_collapse${indexSub}_${zoneIndex}`}
                                          onClick={() => {
                                            let newZoneToggle = clone(zoneToggle);
                                            if (newZoneToggle[channelIndex][indexSub][zoneIndex]) {
                                              newZoneToggle[channelIndex][indexSub][zoneIndex] = false;
                                            } else {
                                              newZoneToggle[channelIndex][indexSub][zoneIndex] = true;
                                            }
                                            setZoneToggle(newZoneToggle);
                                          }}
                                        >
                                          {intl.formatMessage({ id: "zone.mayus" })} {zoneIndex + 1}
                                        </Button>
                                      </Badge>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        style={{
                                          margin: "0.5rem 0 0 0.5rem",
                                          backgroundColor: palette.secondary,
                                          color: "white",
                                        }}
                                        id={`channel${channelIndex}_collapse${indexSub}_${zoneIndex}`}
                                        onClick={() => {
                                          let newZoneToggle = clone(zoneToggle);
                                          if (newZoneToggle[channelIndex][indexSub][zoneIndex]) {
                                            newZoneToggle[channelIndex][indexSub][zoneIndex] = false;
                                          } else {
                                            newZoneToggle[channelIndex][indexSub][zoneIndex] = true;
                                          }
                                          setZoneToggle(newZoneToggle);
                                        }}
                                      >
                                        {intl.formatMessage({ id: "zone.mayus" })} {zoneIndex + 1}
                                      </Button>
                                    )}

                                    <ThemeProvider theme={theme}>
                                      <Dialog
                                        maxWidth="md"
                                        open={zoneToggle[channelIndex][indexSub][zoneIndex]}
                                        onClose={() => {
                                          let newZoneToggle = clone(zoneToggle);
                                          newZoneToggle[channelIndex][indexSub][zoneIndex] = false;
                                          setZoneToggle(newZoneToggle);
                                        }}
                                      >
                                        <DialogTitle>
                                          {intl.formatMessage({ id: "zone.mayus" })} {zoneIndex + 1}
                                        </DialogTitle>
                                        <DialogContent>
                                          <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            sx={{ marginTop: "2%" }}
                                          >
                                            <Grid item xs={3}>
                                              <TextField
                                                inputProps={{ min: 0, step: "0.1" }}
                                                label={intl.formatMessage({ id: "range.min" })}
                                                type="number"
                                                variant="outlined"
                                                fullWidth
                                                key={`equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`}
                                                error={
                                                  errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`]
                                                    ? true
                                                    : false
                                                }
                                                defaultValue={zone.ini}
                                                disabled={disabled}
                                                onChange={(e) => {
                                                  minHandler({
                                                    channelIndex,
                                                    e,
                                                    equipments,
                                                    errors,
                                                    indexSub,
                                                    selectedEquipment,
                                                    setEquipments,
                                                    setErrors,
                                                    setSelectedEquipment,
                                                    zoneIndex,
                                                  });
                                                }}
                                              />
                                              {!isNil(
                                                errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`],
                                              ) && (
                                                <ErrorText style={{ margin: "0.2rem" }}>
                                                  {intl.formatMessage({
                                                    id: errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`],
                                                  })}
                                                </ErrorText>
                                              )}
                                            </Grid>
                                            <Grid item xs={1} style={{ textAlign: "center" }}>
                                              <Typography variant="h6">-</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                              <TextField
                                                inputProps={{ min: 0, step: "0.1" }}
                                                key={`equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`}
                                                label={intl.formatMessage({ id: "range.max" })}
                                                type="number"
                                                variant="outlined"
                                                fullWidth
                                                defaultValue={zone.end}
                                                value={zone.end}
                                                disabled={disabled}
                                                error={
                                                  errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`]
                                                    ? true
                                                    : false
                                                }
                                                onChange={(e) => {
                                                  maxHandler({
                                                    e,
                                                    selectedEquipment,
                                                    equipments,
                                                    setSelectedEquipment,
                                                    setEquipments,
                                                    polylineDisplay,
                                                    channelIndex,
                                                    indexSub,
                                                    zoneIndex,
                                                    errors,
                                                    setErrors,
                                                  });
                                                }}
                                              />
                                              {!isNil(
                                                errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`],
                                              ) && (
                                                <ErrorText style={{ margin: "0.2rem" }}>
                                                  {intl.formatMessage({
                                                    id: errors[`equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`],
                                                  })}
                                                </ErrorText>
                                              )}
                                            </Grid>
                                          </Grid>
                                          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                            <Autocomplete
                                              multiple
                                              id="measurand_select"
                                              variant="outlined"
                                              options={
                                                configData.alertConfiguration?.filter(
                                                  (option) => option.category !== "equipment",
                                                ) || []
                                              }
                                              value={
                                                !isNil(
                                                  selectedEquipment.channels[channelIndex].substructures[indexSub]
                                                    .zones[zoneIndex].alertsConfigurations,
                                                )
                                                  ? selectedEquipment.channels[channelIndex].substructures[indexSub]
                                                      .zones[zoneIndex].alertsConfigurations
                                                  : []
                                              }
                                              sx={{
                                                width: "16rem", // aumenta el ancho para que quepan más chips
                                                ".MuiChip-root": {
                                                  maxWidth: "100%", // permite que los chips no se corten
                                                },
                                                ".MuiAutocomplete-tag": {
                                                  maxWidth: "calc(100% - 16px)", // previene overflow
                                                },
                                                marginTop: "4%",
                                              }}
                                              disabled={disabled}
                                              disableCloseOnSelect
                                              onChange={(event, values) => {
                                                handleAlertConfig({
                                                  equipments,
                                                  selectedEquipment,
                                                  channelIndex,
                                                  indexSub,
                                                  zoneIndex,
                                                  values,
                                                  setSelectedEquipment,
                                                  setEquipments,
                                                });
                                              }}
                                              getOptionLabel={(option) => option.name}
                                              isOptionEqualToValue={(option, value) => option.name === value.name}
                                              renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                  <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                                  {option.name}
                                                </li>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  variant="outlined"
                                                  label={intl.formatMessage({ id: "alert.config" })}
                                                />
                                              )}
                                              required
                                            />
                                            <IconButton
                                              style={{ backgroundColor: palette.dividerLight }}
                                              disabled={disabled}
                                              onClick={() => {
                                                //Abrir el Modal para crear una configuración de alerta
                                                setOpenModal(true);
                                              }}
                                            >
                                              <AddIcon sx={{ color: palette.primary }} />
                                            </IconButton>
                                          </div>
                                          {openModal && (
                                            <AlertConfig
                                              open={openModal}
                                              setOpen={setOpenModal}
                                              configData={configData}
                                              assetsData={assetsData}
                                              selectedAsset={selectedAsset}
                                              selectedEquipment={selectedEquipment}
                                              equipmentTypes={equipmentTypes}
                                            />
                                          )}
                                        </DialogContent>
                                        <DialogActions>
                                          <Button
                                            variant="contained"
                                            style={{ backgroundColor: palette.secondary, color: "white" }}
                                            onClick={() => {
                                              let newZoneToggle = clone(zoneToggle);
                                              newZoneToggle[channelIndex][indexSub][zoneIndex] = false;
                                              setZoneToggle(newZoneToggle);
                                            }}
                                          >
                                            {intl.formatMessage({ id: "accept" })}
                                          </Button>
                                        </DialogActions>
                                      </Dialog>
                                    </ThemeProvider>
                                  </Grid>
                                ),
                              )}
                          </Grid>
                        </Collapse>
                      </div>
                    );
                  })}
              </Collapse>
            </>
          ))}
        </Grid>
      </div>
    </section>
  );
};

export default MeasurementInfo;
